export default __webpack_public_path__ + "static/media/lords-circle.bc42a746.png";